import './side-menu.scss'

import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';


@Component({
    props: ['toggleSideMenuTopic', 'forceCloseMenuTopic'],
    template: require('./side-menu.html')
})
export class SideMenu extends ReactiveVue {

    public isDisplayed: boolean = false;
    public toggleSideMenuTopic: string;
    public forceCloseMenuTopic: string;

    public mounted() {
        this.subscribeToBus(this.toggleSideMenuTopic, message => this.toggleMenu(message))
        this.subscribeToBus(this.forceCloseMenuTopic, message => this.isDisplayed = false)
    }

    public toggleMenu(message: any) {
        this.isDisplayed = !this.isDisplayed;
    }

}